import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

interface RelatedProductsProps {
  relatedSlugs: string[];
}

export default function RelatedProducts({ relatedSlugs }: RelatedProductsProps) {
  const related = relatedSlugs
    .map((slug) => products.find((p) => p.slug === slug))
    .filter(Boolean)
    .slice(0, 3);

  if (related.length === 0) return null;

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <h2 className="text-3xl font-black text-gray-900 uppercase mb-8">Outros Equipamentos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {related.map((p) => (
            <Link
              key={p!.slug}
              to={p!.href}
              className="bg-white rounded-2xl p-5 flex items-center gap-4 border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-gray-50 rounded-xl flex-shrink-0">
                <img
                  alt={`Máquina de solda de geomembrana ${p!.name}`}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  src={p!.image}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="min-w-0">
                <h3 className="text-lg font-black text-gray-900 uppercase leading-tight mb-1">{p!.name}</h3>
                <p className="text-gray-400 text-xs font-bold truncate">{p!.subtitle}</p>
                <span className="inline-flex items-center gap-1 text-green-500 text-xs font-black uppercase tracking-wide mt-1.5">
                  Ver detalhes <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/maquinas-de-solda-de-geomembrana"
            className="inline-flex items-center gap-2 border-2 border-green-500 text-green-600 hover:bg-green-500 hover:text-white text-sm font-black px-6 py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            Ver outros modelos de máquinas de solda de geomembrana
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </div>
  );
}
